import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { when } from 'mobx'
import { observer, inject } from 'mobx-react'

@inject(['auth'])
@observer
class InitialPasswordForm extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  state = {
    error: false,
    processing: false
  }

  componentWillMount() {
    const { location: { state } } = this.props
    const token    = this.props.location.query.token

    this.props.auth.newInitialPassword(token)
      .catch(() => {
        this.context.router.replace({ pathname: '/login' })
      })

    this.authWatcher = when(
      () => this.props.auth.loggedIn,
      () => this.context.router.push(state && state.return_to || { pathname: '/' })
    )
  }

  componentWillUnmount() {
    this.authWatcher()
  }

  handleSubmit = (event) => {
    event.preventDefault()
    this.setState({ error: false, processing: true })

    const token    = this.props.location.query.token
    const password = this.password.value

    this.props.auth.setInitialPassword(token, password)
      .catch(() => {
        this.setState({ error: true, processing: false })
      })
  }

  render() {
    let errorMessage = this.state.error && <div className="error">Invalid password. Please try again.</div>

    return (
      <div className="container auth">
        <div className="dialog login">
          <h3>Showcase IDX</h3>

          <div style={{ marginBottom: 10 }}>Please set a secure password for your account.</div>

          <form onSubmit={this.handleSubmit}>
            {errorMessage}
            <div className="form-section">
              <label htmlFor="password">Password</label>
              <input type="password" id="password" title="Password" ref={r => this.password = r} required />
            </div>
            <button type="submit" disabled={this.state.processing}>
              Set Password
              <div className="bounceloader">
                <div className="bounce1"></div>
                <div className="bounce2"></div>
                <div className="bounce3"></div>
              </div>
            </button>
          </form>
        </div>
      </div>
    )
  }
}

export default InitialPasswordForm



// WEBPACK FOOTER //
// client/components/auth/InitialPasswordForm.js